// export const MY_API_URL= import.meta.env.VITE_API_URL;
import LOGO_URL from "../src/assets/logo_transparent.png";
import ICON_URL from "../src/assets/logo_transparent.png";
import QR_CODE from "../src/assets/qr.png";



const APP_NAME = "vehidhi";
const OFFICIAL_NAME = {en: "vehidhi", dv: "ވެހިދި"};
const GSHEET_SAVE_CALLBACK = "https://script.google.com/macros/s/AKfycbxCPaFuN9kheUTUA7eDR2wJDlBW3EJQCydNjaVYlwTzT3IgjXnFh0GOE94TWONPxWrqOg/exec";
const BUCKET_PUBLIC_URL = "https://storage.vehidhi.com";

/// PROD
const PUBLIC_DOMAIN = "https://vehidhi.com";
const API_URL_PROD = "https://api.vehidhi.com";
const GOOGLE_CALLBACK_URL_PROD = "https://api.vehidhi.com/auth/google/callback";
const BML_API_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6IjdjYzg4NjAwLTkxN2YtNDIyMi1hOTA1LWJiYmZhZmRiMzU0OCIsImNvbXBhbnlJZCI6IjY2MmYzNzMzNmVmOTkyMDAwODlkMDhhNyIsImlhdCI6MTcyOTA2NjkwMCwiZXhwIjo0ODg0NzQwNTAwfQ.WIc6EsLqMjwyMQjC2xu82eR3mms0cTMKmT44m1L1yBY";
const FRONTEND_URL_PROD = "https://vehidhi.com";

/// DEV
// const API_URL_DEV = "http://localhost:8787";
// const FRONTEND_URL_DEV = "http://localhost:5173";


const API_URL=import.meta.env.VITE_API_URL || API_URL_PROD;
const FRONTEND_URL=import.meta.env.VITE_FRONTEND_URL || FRONTEND_URL_PROD;
const GOOGLE_CALLBACK_URL = import.meta.env.VITE_GOOGLE_CALLBACK_URL || GOOGLE_CALLBACK_URL_PROD;
const MY_BUCKET_PUBLIC_URL=import.meta.env.VITE_MY_BUCKET_PUBLIC_URL ?? BUCKET_PUBLIC_URL;

export const BML_CONFIG = {
        BML_APP_NAME:"vehidhi",
        BML_API_KEY:BML_API_KEY,
        BML_APP_ID:"7cc88600-917f-4222-a905-bbbfafdb3548",
        BML_DEVICE_ID:"7cc88600-917f-4222-a905-bbbfafdb3548",
        BML_APP_VERSION:"2.0",
    };

// const GOOGLE_OAUTH_CONFIG = {
//         GOOGLE_CALLBACK: import.meta.env.VITE_GOOGLE_CALLBACK_URL || GOOGLE_CALLBACK_URL_PROD,
//         FRONTEND_GOOGLE_CALLBACK: import.meta.env.VITE_GOOGLE_CALLBACK_URL || GOOGLE_CALLBACK_URL_PROD,
//         GOOGLE_CLIENT_ID: "288383278411-1p91uua1hl67aaohhkg1en243eg5qk7c.apps.googleusercontent.com",
//         GOOGLE_CLIENT_SECRET: "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",
//         GOOGLE_REDIRECT_URI: `${API_URL}/auth/google/callback`,
// };

const PHONE = +9609423609; 
const EMAIL =  "info@vehidhi.com";
const LANGUAGES = ["dv","en"];
const MAIN_LANGUAGE = LANGUAGES[0];
const FOUNDED_DATE = 2020;
const COPYRIGHT =  `© 2026 ${APP_NAME} - All rights reserved.`;
const MAILING_ADDRESS = ""

export const DEVELOPER = {
    NAME: "Mohamed Shaan Ahmed",
    EMAIL: "muhammadhshaan@gamil.com",
    CONTACT: +9609423609,
};


// export const MY_API_URL = API_URL.replace(/\/$/, "");

export const MY_CONFIG = {
    accesstokenName:"access_token",
    refreshtokenName:"refresh_token",
    OFFICIAL_NAME,
    API_URL,
    FRONTEND_URL,
    GOOGLE_CALLBACK_URL,
    APP_NAME,
    PUBLIC_DOMAIN,
    BML_CONFIG,
    GSHEET_SAVE_CALLBACK,
    MY_BUCKET_PUBLIC_URL,
    BML_API_KEY,
    LOGO_URL,
    ICON_URL,
    PHONE,
    EMAIL,
    MAIN_LANGUAGE,
    LANGUAGES,
    FOUNDED_DATE,
    MAILING_ADDRESS,
    DEVELOPER,
    QR_CODE,
    COPYRIGHT
}


export default MY_CONFIG;

